import { useQuery, keepPreviousData } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';
import { filtrosAParams, normalizarTicket } from '../mappers';

// Cola de tickets paginada y filtrada. keepPreviousData evita parpadeo al
// cambiar de pagina o filtro (React Query v5).
const useTicketsLista = (headquarter, { page, pageSize, ...filtros } = {}) => {
  const params = filtrosAParams(filtros);
  const queryFiltros = { ...params, page, pageSize };

  return useQuery({
    queryKey: ticketsKeys.lista(headquarter, queryFiltros),
    queryFn: async () => {
      const data = await ticketsService.listarTickets({
        headquarter,
        page,
        pageSize,
        ...params,
      });
      return data && Array.isArray(data.data)
        ? { ...data, data: data.data.map(normalizarTicket) }
        : { total: 0, page, pageSize, data: [] };
    },
    enabled: Boolean(headquarter),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
};

export default useTicketsLista;
